// extracted by mini-css-extract-plugin
module.exports = {"hero":"page-coming-soon-module--hero--1JfVd","title":"page-coming-soon-module--title--1WZki","icon":"page-coming-soon-module--icon--2r17d"};